export enum VendorsRoutePathNames {
  VENDORS = 'vendors',
  LIST = '',
  UPDATE = ':id',
}
